import {useMemo} from 'react';
import {
   PtrnMaestroDetalleConfig,
   UsePtrnEstMstrDet_AddDetalleFn,
   UsePtrnEstMstrDet_AddMultiDetalleFn,
   UsePtrnEstMstrDet_UpdateCampoFn,
   UsePtrnEstMstrDet_UpdateMultiCampoFn,
   UsePtrnEstMstrDet_ResetStateFn,
   UsePtrnEstadoMaestroDetalleHook,
   UsePtrnEstMstrDet_RemoveDetalleFn,
   UsePtrnEstMstrDet_RemoveMultiDetalleFn,
   PtrnMaestroDetalleConfigObj,
   UsePtrnEstMstrDet_SetErrorCampoFn,
   UsePtrnEstMstrDet_SetErrorMultiCampoFn,
   UsePtrnEstMstrDet_RmUpdtMultiCampoFn,
   UsePtrnEstMstrDet_UpdtAddMultiCampoFn,
   UsePtrnEstMstrDet_RmAddUpdtMultiCampoFn,
   UsePtrnEstMstrDet_OverwriteStateFn
} from './usePtrnEstadoMaestroDetalleTypes';
import {PtrnCfgUtils} from '../../patronUtils';
import {
   PtrnCampoBase,
   PtrnCampoEditableBase,
   PtrnCamposEditablesConfigObject
} from '../../patronTypes';
import useRdcrMstrDet, {RdcrMstrDetAccionTipo} from './useRdcrMstrDet';
import ptrnProcesarCampo from '../../patronUtils/ptrnProcesarCampo';
import {transformacion} from 'lib.common';
import {PtrnProcesarUtilsCfg} from '../../patronUtils/ptrnProcesarCampo/ptrnProcesarUtils';

function aplanarConfiguracionMaestroDetalle(cfg: PtrnMaestroDetalleConfig): {
   primitivas: PtrnMaestroDetalleConfig;
   obj: PtrnMaestroDetalleConfigObj;
} {
   const currcfgPrimitivas: PtrnMaestroDetalleConfig = {...cfg};
   currcfgPrimitivas.campos = PtrnCfgUtils.extraerPrimitivasCfg<PtrnCampoBase>(
      currcfgPrimitivas.campos
   );
   const currCfgCamposObj = currcfgPrimitivas.campos.reduce<PtrnCamposEditablesConfigObject>(
      (prev, curr) => {
         prev[curr.name] = curr;
         return prev;
      },
      {}
   );

   const currCfgObj: PtrnMaestroDetalleConfigObj = {
      id: cfg.id,
      getId: cfg.getId,
      campos: currCfgCamposObj
   };

   if (currcfgPrimitivas.detalles && currcfgPrimitivas.detalles.length > 0) {
      if (!currCfgObj.detalles) {
         currCfgObj.detalles = {};
      }

      for (let cfgDetInx = 0; cfgDetInx < currcfgPrimitivas.detalles.length; cfgDetInx++) {
         const resumenDet = aplanarConfiguracionMaestroDetalle(
            currcfgPrimitivas.detalles[cfgDetInx]
         );
         currcfgPrimitivas.detalles[cfgDetInx] = resumenDet.primitivas;
         currCfgObj.detalles[currcfgPrimitivas.detalles[cfgDetInx].id] = resumenDet.obj;
      }
   }
   return {
      primitivas: currcfgPrimitivas,
      obj: currCfgObj
   };
}

const usePtrnEstadoMaestroDetalle: UsePtrnEstadoMaestroDetalleHook = (
   cfgIn: PtrnMaestroDetalleConfig
) => {
   const cfg = useMemo(() => {
      return aplanarConfiguracionMaestroDetalle(cfgIn);
   }, [cfgIn]);

   const [state, dispatch] = useRdcrMstrDet(cfg.primitivas);

   //#region reducer factory
   //
   //
   //
   //

   //#region >change campo
   const updateCampo: UsePtrnEstMstrDet_UpdateCampoFn = (payload) => {
      const {campoName, path, valor} = payload;
      // obtener la configuracion del campo
      let currentMDCfg = PtrnProcesarUtilsCfg.getValidCfgMD(cfg.obj, {
         campoNombre: campoName,
         pathState: path,
         origen: 'usePtrnEstadoMaestroDetalle'
      });

      let campoConfig: PtrnCampoEditableBase = currentMDCfg.campos[campoName];
      const loacalState = transformacion.getAttrEnRuta(path, state);

      const resultadoProcesarValor = ptrnProcesarCampo(
         valor.valor,
         campoConfig,
         loacalState,
         state,
         {
            campoNombre: campoName,
            origen: `usePtrnEstadoSimple->handleOnChange`
         }
      );

      PtrnProcesarUtilsCfg.execAfterProcesarCampo({
         resultadoProcesarValor,
         campoConfig,
         onSetError: () => {
            dispatch({
               type: RdcrMstrDetAccionTipo.SET_ERROR_CAMPO,
               payload: {
                  path: path,
                  campoName,
                  errores: resultadoProcesarValor.valorProcesado.errores
               }
            });
         },
         onSetNewValue: () => {
            dispatch({type: RdcrMstrDetAccionTipo.UPDATE_CAMPO, payload});
         },
         newState: {
            ...transformacion.getAttrEnRuta(path, state),
            [campoName]: {
               valor: resultadoProcesarValor.valorProcesado.valor,
               errores: resultadoProcesarValor.valorProcesado.errores,
               fueModificado: true
            }
         },
         auxParam: {
            ptrnRef: {setMDState: updateCampo}
         }
      });
   };

   const updateMultiCampo: UsePtrnEstMstrDet_UpdateMultiCampoFn = (payload) => {
      //TODO: implementar aplicacion de validacion para multiples campos si es necesario a futuro
      dispatch({type: RdcrMstrDetAccionTipo.UPDATE_MULTI_CAMPO, payload});
   };
   //#endregion

   //#region >add detalle
   const addDetalle: UsePtrnEstMstrDet_AddDetalleFn = (payload) => {
      dispatch({type: RdcrMstrDetAccionTipo.ADD_DETALLE, payload});
   };

   const addMultiDetalle: UsePtrnEstMstrDet_AddMultiDetalleFn = (payload) => {
      dispatch({type: RdcrMstrDetAccionTipo.ADD_MULTI_DETALLE, payload});
   };
   //#endregion

   //#region >remove detalle
   const removeDetalle: UsePtrnEstMstrDet_RemoveDetalleFn = (payload) => {
      dispatch({type: RdcrMstrDetAccionTipo.REMOVE_DETALLE, payload});
   };
   const removeMultiDetalle: UsePtrnEstMstrDet_RemoveMultiDetalleFn = (payload) => {
      dispatch({type: RdcrMstrDetAccionTipo.REMOVE_MULTI_DETALLE, payload});
   };
   //#endregion

   //#region >reset detalle
   const resetState: UsePtrnEstMstrDet_ResetStateFn = (payload) => {
      dispatch({type: RdcrMstrDetAccionTipo.RESET_STATE, payload});
   };
   //#endregion

   //#region >reset detalle
   const overWriteState: UsePtrnEstMstrDet_OverwriteStateFn = (payload) => {
      dispatch({type: RdcrMstrDetAccionTipo.OVERWRITE_STATE, payload});
   };
   //#endregion

   //#region set error
   const setErrorCampo: UsePtrnEstMstrDet_SetErrorCampoFn = (payload) => {
      dispatch({type: RdcrMstrDetAccionTipo.SET_ERROR_CAMPO, payload});
   };
   const setErrorMultiCampo: UsePtrnEstMstrDet_SetErrorMultiCampoFn = (payload) => {
      dispatch({type: RdcrMstrDetAccionTipo.SET_ERROR_MULTI_CAMPO, payload});
   };
   //#endregion
   //#region rm up
   const removeUpsertMultiCampo: UsePtrnEstMstrDet_RmUpdtMultiCampoFn = (payload) => {
      dispatch({type: RdcrMstrDetAccionTipo.REMOVE_UPSERT_MULTI, payload});
   };
   //#endregion
   //#region updata add
   const updateAddMultiCampo: UsePtrnEstMstrDet_UpdtAddMultiCampoFn = (payload) => {
      dispatch({type: RdcrMstrDetAccionTipo.UPDATE_ADD_MULTI, payload});
   };
   //#endregion

   //#region updata add
   const rmAddUpdtMultiCampo: UsePtrnEstMstrDet_RmAddUpdtMultiCampoFn = (payload) => {
      dispatch({type: RdcrMstrDetAccionTipo.RM_ADD_UPDT_MULTI, payload});
   };
   //#endregion
   //#endregion

   return {
      state,
      updateCampo,
      updateMultiCampo,
      addDetalle,
      addMultiDetalle,
      resetState,
      overWriteState,
      removeDetalle,
      removeMultiDetalle,
      setErrorCampo,
      setErrorMultiCampo,
      removeUpsertMultiCampo,
      updateAddMultiCampo,
      rmAddUpdtMultiCampo,
      cfg
   };
};

export default usePtrnEstadoMaestroDetalle;
